import React from 'react';

/* Added the following code for POW-950.Harsha using AI Agent. October 7, 2026. Code Start */
const ManagePartnerSubmissionsConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/upload/managepartners',
			component: React.lazy(() => import('./ManagePartnerSubmissions'))
		}
	]
};

export default ManagePartnerSubmissionsConfig;
/* Code end. Harsha using AI Agent. October 7, 2026 */
